import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './styles/mobile.css'
import App from './App.tsx'
import { AuthProvider } from './contexts/AuthContext'
import { ThemeProvider } from './contexts/ThemeContext'
import { useWebVitals, useBundleMonitor } from './hooks/useMonitoring'

// Service Worker automaticamente gestito da vite-plugin-pwa

const AppWithMonitoring: React.FC = () => {
  // Abilita monitoraggio performance in development
  useWebVitals();
  useBundleMonitor();

  return <App />;
};

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <AppWithMonitoring />
      </AuthProvider>
    </ThemeProvider>
  </StrictMode>
);
